import axiosInstance from "./axiosInstance";

// Posts search
export const searchPosts = async (query, page = 1) => {
  const response = await axiosInstance.get(`/posts/search/`, {
    params: { q: query, page },
  });
  return {
    posts: response.data?.results || response.data || [],
    next: response.data?.next || null,
  };
};

// Users search
export const searchUsers = async (query) => {
  const response = await axiosInstance.get(`/posts/search/`, {
    params: { q: query, type: "user" },
  });
  return response.data?.results || response.data || [];
};

// Explore posts
export const getExplorePosts = async (page = 1) => {
  const response = await axiosInstance.get(`/posts/explore/`, {
    params: { page },
  });
  return {
    posts: response.data?.results || response.data || [],
    next: response.data?.next || null,
  };
};